/**
 * Stammdaten API
 * API for Stammdaten Component
 *
 * The version of the OpenAPI document: -
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

import { CodeEntry } from '../model/models';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';



@Injectable({
  providedIn: 'root'
})
export class GbcapicodeService {

    protected basePath = 'http://localhost';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();
    public encoder: HttpParameterCodec;

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }



    private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
        if (typeof value === "object" && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        } else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }

    private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
        if (value == null) {
            return httpParams;
        }

        if (typeof value === "object") {
            if (Array.isArray(value)) {
                (value as any[]).forEach( elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
            } else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key,
                        (value as Date).toISOString().substr(0, 10));
                } else {
                   throw Error("key may not be null if value is Date");
                }
            } else {
                Object.keys(value).forEach( k => httpParams = this.addToHttpParamsRecursive(
                    httpParams, value[k], key != null ? `${key}.${k}` : k));
            }
        } else if (key != null) {
            httpParams = httpParams.append(key, value);
        } else {
            throw Error("key may not be null if value is not object or array");
        }
        return httpParams;
    }

    /**
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public load(id: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<CodeEntry>;
    public load(id: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<CodeEntry>>;
    public load(id: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<CodeEntry>>;
    public load(id: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling load.');
        }

        let headers = this.defaultHeaders;

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<CodeEntry>(`${this.configuration.basePath}/gb/capicode/${encodeURIComponent(String(id))}`,
            {
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param type 
     * @param gueltig 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public loadCapiCodes(type: 'ANMERKUNG' | 'ANREDE' | 'AUFGABE' | 'AV_BEMERKUNG' | 'BEWERTUNGSGRUND' | 'BODENBEDECKUNG' | 'DIENSTBARKEIT_GRUNDLAST' | 'EXTERNER_HINWEIS' | 'FUNKTION_BENUTZER' | 'GEBAEUDE' | 'GEBUEHR' | 'GESCHAEFT_BESCHREIBUNG' | 'GESELLSCHAFTSFORM' | 'GESETZLICHES_PFANDRECHT' | 'GLAEUBIGER_ROLLE' | 'SCHULDNER_ROLLE' | 'GRUNDSTUECK_UNTER_ART_LIG' | 'GRUNDSTUECK_UNTER_ART_SDR' | 'KENNZEICHNUNG_GEO_GESCHAEFT' | 'NACHRUECK_RECHT' | 'PERSONEN_GRUPPE' | 'PFANDRECHT' | 'PFANDRECHT_BEMERKUNG' | 'QUALITAET_FLAECHE' | 'RECHTSFORM' | 'RECHTSGRUND' | 'SPRACHE' | 'UID_STATUS' | 'VERTRAGSART' | 'VORMERKUNG' | 'DOKUMENTENART_DECKBLATT', gueltig?: boolean, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<Array<CodeEntry>>;
    public loadCapiCodes(type: 'ANMERKUNG' | 'ANREDE' | 'AUFGABE' | 'AV_BEMERKUNG' | 'BEWERTUNGSGRUND' | 'BODENBEDECKUNG' | 'DIENSTBARKEIT_GRUNDLAST' | 'EXTERNER_HINWEIS' | 'FUNKTION_BENUTZER' | 'GEBAEUDE' | 'GEBUEHR' | 'GESCHAEFT_BESCHREIBUNG' | 'GESELLSCHAFTSFORM' | 'GESETZLICHES_PFANDRECHT' | 'GLAEUBIGER_ROLLE' | 'SCHULDNER_ROLLE' | 'GRUNDSTUECK_UNTER_ART_LIG' | 'GRUNDSTUECK_UNTER_ART_SDR' | 'KENNZEICHNUNG_GEO_GESCHAEFT' | 'NACHRUECK_RECHT' | 'PERSONEN_GRUPPE' | 'PFANDRECHT' | 'PFANDRECHT_BEMERKUNG' | 'QUALITAET_FLAECHE' | 'RECHTSFORM' | 'RECHTSGRUND' | 'SPRACHE' | 'UID_STATUS' | 'VERTRAGSART' | 'VORMERKUNG' | 'DOKUMENTENART_DECKBLATT', gueltig?: boolean, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<Array<CodeEntry>>>;
    public loadCapiCodes(type: 'ANMERKUNG' | 'ANREDE' | 'AUFGABE' | 'AV_BEMERKUNG' | 'BEWERTUNGSGRUND' | 'BODENBEDECKUNG' | 'DIENSTBARKEIT_GRUNDLAST' | 'EXTERNER_HINWEIS' | 'FUNKTION_BENUTZER' | 'GEBAEUDE' | 'GEBUEHR' | 'GESCHAEFT_BESCHREIBUNG' | 'GESELLSCHAFTSFORM' | 'GESETZLICHES_PFANDRECHT' | 'GLAEUBIGER_ROLLE' | 'SCHULDNER_ROLLE' | 'GRUNDSTUECK_UNTER_ART_LIG' | 'GRUNDSTUECK_UNTER_ART_SDR' | 'KENNZEICHNUNG_GEO_GESCHAEFT' | 'NACHRUECK_RECHT' | 'PERSONEN_GRUPPE' | 'PFANDRECHT' | 'PFANDRECHT_BEMERKUNG' | 'QUALITAET_FLAECHE' | 'RECHTSFORM' | 'RECHTSGRUND' | 'SPRACHE' | 'UID_STATUS' | 'VERTRAGSART' | 'VORMERKUNG' | 'DOKUMENTENART_DECKBLATT', gueltig?: boolean, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<Array<CodeEntry>>>;
    public loadCapiCodes(type: 'ANMERKUNG' | 'ANREDE' | 'AUFGABE' | 'AV_BEMERKUNG' | 'BEWERTUNGSGRUND' | 'BODENBEDECKUNG' | 'DIENSTBARKEIT_GRUNDLAST' | 'EXTERNER_HINWEIS' | 'FUNKTION_BENUTZER' | 'GEBAEUDE' | 'GEBUEHR' | 'GESCHAEFT_BESCHREIBUNG' | 'GESELLSCHAFTSFORM' | 'GESETZLICHES_PFANDRECHT' | 'GLAEUBIGER_ROLLE' | 'SCHULDNER_ROLLE' | 'GRUNDSTUECK_UNTER_ART_LIG' | 'GRUNDSTUECK_UNTER_ART_SDR' | 'KENNZEICHNUNG_GEO_GESCHAEFT' | 'NACHRUECK_RECHT' | 'PERSONEN_GRUPPE' | 'PFANDRECHT' | 'PFANDRECHT_BEMERKUNG' | 'QUALITAET_FLAECHE' | 'RECHTSFORM' | 'RECHTSGRUND' | 'SPRACHE' | 'UID_STATUS' | 'VERTRAGSART' | 'VORMERKUNG' | 'DOKUMENTENART_DECKBLATT', gueltig?: boolean, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        if (type === null || type === undefined) {
            throw new Error('Required parameter type was null or undefined when calling loadCapiCodes.');
        }

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (type !== undefined && type !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>type, 'type');
        }
        if (gueltig !== undefined && gueltig !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>gueltig, 'gueltig');
        }

        let headers = this.defaultHeaders;

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<Array<CodeEntry>>(`${this.configuration.basePath}/gb/capicode`,
            {
                params: queryParameters,
                responseType: <any>responseType,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
